module.exports = __webpack_public_path__ + "site/img/149.c4cf3876.jpg";